import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	issueCountry: null,
	error: "",
	loading: false,
};

// ADD_issueCountry
export const addIssueCountry = createAsyncThunk(
	"issueCountry/addIssueCountry",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `issueCountry`,
				data: {
					...values,
				},
			});
			toast.success("Country of Issue added successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding Country of Issue try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// DELETE_issueCountry
export const deleteIssueCountry = createAsyncThunk(
	"issueCountry/deleteIssueCountry ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `issueCountry/${id}`,
			});

			toast.success("Country of Issue deleted successfully!");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting Country of Issue try again");
			console.log(error.message);
		}
	}
);

// issueCountryS
export const getAllIssueCountry = createAsyncThunk(
	"issueCountry/getAllIssueCountry",
	async () => {
		try {
			const { data } = await axios.get(`issueCountry`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const updateIssueCountry = createAsyncThunk(
	"issueCountry/updateIssueCountry",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `issueCountry/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Country of Issue updated successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating Country of Issue try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

const issueCountrySlice = createSlice({
	name: "issueCountry",
	initialState,
	reducers: {
		clearIssueCountry: (state) => {
			state.issueCountry = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllIssueCountry ======

		builder.addCase(getAllIssueCountry.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllIssueCountry.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAllIssueCountry.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addIssueCountry  ======

		builder.addCase(addIssueCountry.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addIssueCountry.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addIssueCountry.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});




		// 3) ====== builders for issueCountry ======

		builder.addCase(updateIssueCountry.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateIssueCountry.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateIssueCountry.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteIssueCountry  ======

		builder.addCase(deleteIssueCountry.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteIssueCountry.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteIssueCountry.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default issueCountrySlice.reducer;
export const { clearIssueCountry } = issueCountrySlice.actions;
